import React, { useState } from "react";
import { t } from '../../../i18n';
import { Query, Mutation } from "react-apollo";
import queries from "../../../queries";
import { FormattedMessage, injectIntl } from "react-intl";
import ImageUploader from "../../uploaders/ImageUploader";
import PaletteColorPicker from "../../PaletteColorPicker";
import {withRouter} from "react-router-dom";
import PhotoboothCellStatsButton from "../PhotoboothCellStatsButton";
import PhotoboothCellPhotosZipButton from "../PhotoboothCellPhotosZipButton";
import EditorSection from "./EditorSection";

function PhotoboothGifCell2EditorWrapper({...props}) {

  const {projectId, pageId} = props.match.params;

  const cell = props.cell || props.initialCellData;

  const language = props.language;

  if (!cell) {
    return <p>No cell data provided.</p>;
  }

  return (
    <Query query={queries.cells.photobooth_gif2.get} variables={{ id: cell.id }}>
      {({ loading, error, data }) => {
        if (loading) return <p>{t('ui.common.loading')}</p>;
        if (error) return <p>Error: {error.message}</p>;
        if (!data) return null;
        if(!!language) {
          return <PhotoboothGifCell2EditorInner projectId={projectId} pageId={pageId} language={language} initialCellData={{...data.photoboothGifCell2, language}} />;
        }
        return <PhotoboothGifCell2EditorInner projectId={projectId} pageId={pageId} initialCellData={data.photoboothGifCell2} />;
      }}
    </Query>
  );
}

const PhotoboothGifCell2EditorInner = injectIntl(function PhotoboothGifCell2EditorInnerBase({ initialCellData, projectId, pageId, language, intl }) {
  const [cellData, setCellData] = useState(initialCellData);

  if (!cellData) {
    return <p>No cell data provided.</p>;
  }

  return (
    <Mutation
      mutation={language ? queries.cells.i18n.update : queries.cells.photobooth_gif2.update}
      refetchQueries={[
        { query: queries.cells.photobooth_gif2.get, variables: { id: cellData.id } },
      ]}
    >
      {(updateCell, { loading: mutationLoading, error: mutationError }) => (
        <>
          {mutationError && <p>Error: {mutationError.message}</p>}

          {/* You can use the additional data here if you need it */}
          <Query query={queries.projects.getWithChildren} variables={{ id: projectId }}>
            {({ loading, error, data }) => {
              if (loading) return <p>Loading project data...</p>;
              if (error) return <p>Error loading project: {error.message}</p>;
              if (!data) return null;

              const {project} = data;
              // Use data.project here if needed, but don't re-render the component
              return (
                <div className="tsk-editor-form">
                  {!language && (
                    <>
                      <EditorSection title={<FormattedMessage id="projects.photobooth.gif.cell.colors_section" />}>
                        <EditorSection nested title={<FormattedMessage id="projects.photobooth.gif.cell.colors_section.background" />}>
                          <div className="tsk-input-line">
                            <label><FormattedMessage id="projects.photobooth.gif.cell.background_color" /></label>
                            <PaletteColorPicker
                              palette={project.color_palette}
                              color={cellData.background_color}
                              onChange={(val) => {const {rgb} = val; setCellData({ ...cellData, background_color: `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})` })}}
                            />
                          </div>
                          <div className="tsk-input-line">
                            <label><FormattedMessage id="projects.photobooth.gif.cell.button_download_background_color" /></label>
                            <PaletteColorPicker
                              palette={project.color_palette}
                              color={cellData.button_download_background_color}
                              onChange={(val) => {const {rgb} = val; setCellData({ ...cellData, button_download_background_color: `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})` })}}
                            />
                          </div>
                          <div className="tsk-input-line">
                            <label><FormattedMessage id="projects.photobooth.gif.cell.button_retake_background_color" /></label>
                            <PaletteColorPicker
                              palette={project.color_palette}
                              color={cellData.button_retake_background_color}
                              onChange={(val) => {const {rgb} = val; setCellData({ ...cellData, button_retake_background_color: `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})` })}}
                            />
                          </div>
                          <div className="tsk-input-line">
                            <label><FormattedMessage id="projects.photobooth.gif.cell.button_print_background_color" /></label>
                            <PaletteColorPicker
                              palette={project.color_palette}
                              color={cellData.button_print_background_color}
                              onChange={(val) => {const {rgb} = val; setCellData({ ...cellData, button_print_background_color: `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})` })}}
                            />
                          </div>
                          <div className="tsk-input-line">
                            <label><FormattedMessage id="projects.photobooth.gif.cell.email_card_background_color" /></label>
                            <PaletteColorPicker
                              palette={project.color_palette}
                              color={cellData.email_card_background_color}
                              onChange={(val) => {const {rgb} = val; setCellData({ ...cellData, email_card_background_color: `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})` })}}
                            />
                          </div>
                          <div className="tsk-input-line">
                            <label><FormattedMessage id="projects.photobooth.gif.cell.email_input_background_color" /></label>
                            <PaletteColorPicker
                              palette={project.color_palette}
                              color={cellData.email_input_background_color}
                              onChange={(val) => {const {rgb} = val; setCellData({ ...cellData, email_input_background_color: `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})` })}}
                            />
                          </div>
                          <div className="tsk-input-line">
                            <label><FormattedMessage id="projects.photobooth.gif.cell.send_button_background_color" /></label>
                            <PaletteColorPicker
                              palette={project.color_palette}
                              color={cellData.send_button_background_color}
                              onChange={(val) => {const {rgb} = val; setCellData({ ...cellData, send_button_background_color: `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})` })}}
                            />
                          </div>
                          <div className="tsk-input-line">
                            <label><FormattedMessage id="projects.photobooth.gif.cell.qr_card_background_color" /></label>
                            <PaletteColorPicker
                              palette={project.color_palette}
                              color={cellData.qr_card_background_color}
                              onChange={(val) => {const {rgb} = val; setCellData({ ...cellData, qr_card_background_color: `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})` })}}
                            />
                          </div>
                          <div className="tsk-input-line">
                            <label><FormattedMessage id="projects.photobooth.gif.cell.loader_background_color" /></label>
                            <PaletteColorPicker
                              palette={project.color_palette}
                              color={cellData.loader_background_color}
                              onChange={(val) => {const {rgb} = val; setCellData({ ...cellData, loader_background_color: `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})` })}}
                            />
                          </div>
                        </EditorSection>

                        <EditorSection nested title={<FormattedMessage id="projects.photobooth.gif.cell.colors_section.text" />}>
                          <div className="tsk-input-line">
                            <label><FormattedMessage id="projects.photobooth.gif.cell.text_color" /></label>
                            <PaletteColorPicker
                              palette={project.color_palette}
                              color={cellData.text_color}
                              onChange={(val) => {const {rgb} = val; setCellData({ ...cellData, text_color: `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})` })}}
                            />
                          </div>
                          {/* The two camera-screen prompts sit on the live feed, so they often need
                              a different color from text on the share background. Left empty, each
                              falls back to the global text color above. */}
                          <div className="tsk-input-line">
                            <label><FormattedMessage id="projects.photobooth.gif.cell.button_take_text_color" /></label>
                            <PaletteColorPicker
                              palette={project.color_palette}
                              color={cellData.button_take_text_color}
                              onChange={(val) => {const {rgb} = val; setCellData({ ...cellData, button_take_text_color: `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})` })}}
                            />
                          </div>
                          <div className="tsk-input-line">
                            <label><FormattedMessage id="projects.photobooth.gif.cell.look_text_color" /></label>
                            <PaletteColorPicker
                              palette={project.color_palette}
                              color={cellData.look_text_color}
                              onChange={(val) => {const {rgb} = val; setCellData({ ...cellData, look_text_color: `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})` })}}
                            />
                          </div>
                          <div className="tsk-input-line">
                            <label><FormattedMessage id="projects.photobooth.gif.cell.arrows_color" /></label>
                            <PaletteColorPicker
                              palette={project.color_palette}
                              color={cellData.arrows_color}
                              onChange={(val) => {const {rgb} = val; setCellData({ ...cellData, arrows_color: `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})` })}}
                            />
                          </div>
                          <div className="tsk-input-line">
                            <label><FormattedMessage id="projects.photobooth.gif.cell.button_download_text_color" /></label>
                            <PaletteColorPicker
                              palette={project.color_palette}
                              color={cellData.button_download_text_color}
                              onChange={(val) => {const {rgb} = val; setCellData({ ...cellData, button_download_text_color: `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})` })}}
                            />
                          </div>
                          <div className="tsk-input-line">
                            <label><FormattedMessage id="projects.photobooth.gif.cell.email_input_text_color" /></label>
                            <PaletteColorPicker
                              palette={project.color_palette}
                              color={cellData.email_input_text_color}
                              onChange={(val) => {const {rgb} = val; setCellData({ ...cellData, email_input_text_color: `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})` })}}
                            />
                          </div>
                          <div className="tsk-input-line">
                            <label><FormattedMessage id="projects.photobooth.gif.cell.send_button_text_color" /></label>
                            <PaletteColorPicker
                              palette={project.color_palette}
                              color={cellData.send_button_text_color}
                              onChange={(val) => {const {rgb} = val; setCellData({ ...cellData, send_button_text_color: `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})` })}}
                            />
                          </div>
                          <div className="tsk-input-line">
                            <label><FormattedMessage id="projects.photobooth.gif.cell.button_retake_text_color" /></label>
                            <PaletteColorPicker
                              palette={project.color_palette}
                              color={cellData.button_retake_text_color}
                              onChange={(val) => {const {rgb} = val; setCellData({ ...cellData, button_retake_text_color: `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})` })}}
                            />
                          </div>
                        </EditorSection>

                        <EditorSection nested title={<FormattedMessage id="projects.photobooth.gif.cell.colors_section.other" />}>
                          <div className="tsk-input-line">
                            <label><FormattedMessage id="projects.photobooth.gif.cell.button_retake_border_color" /></label>
                            <PaletteColorPicker
                              palette={project.color_palette}
                              color={cellData.button_retake_border_color}
                              onChange={(val) => {const {rgb} = val; setCellData({ ...cellData, button_retake_border_color: `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})` })}}
                            />
                          </div>
                          <div className="tsk-input-line">
                            <label><FormattedMessage id="projects.photobooth.gif.cell.qr_code_color" /></label>
                            <PaletteColorPicker
                              palette={project.color_palette}
                              color={cellData.qr_code_color}
                              onChange={(val) => {const {rgb} = val; setCellData({ ...cellData, qr_code_color: `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})` })}}
                            />
                          </div>
                          <div className="tsk-input-line">
                            <label><FormattedMessage id="projects.photobooth.gif.cell.loader_spinner_color" /></label>
                            <PaletteColorPicker
                              palette={project.color_palette}
                              color={cellData.loader_spinner_color}
                              onChange={(val) => {const {rgb} = val; setCellData({ ...cellData, loader_spinner_color: `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})` })}}
                            />
                          </div>
                        </EditorSection>
                      </EditorSection>

                      <EditorSection defaultOpen={false} title={<FormattedMessage id="projects.photobooth.gif.cell.text_tool_section" />}>
                        <div className="tsk-input-line">
                          <label><FormattedMessage id="projects.photobooth.gif.cell.text_font" /></label>
                          <select
                            value={cellData.text_font || ''}
                            onChange={(e) => setCellData({ ...cellData, text_font: e.target.value })}
                          >
                            <option value="">{intl.formatMessage({ id: "cell.button.default.label" })}</option>
                            {project.fonts.map((f) => <option key={f.id} value={f.name}>{f.name}</option>)}
                          </select>
                        </div>
                        <div className="tsk-input-line">
                          <label><FormattedMessage id="projects.photobooth.gif.cell.text_size" /></label>
                          <input
                            type="number"
                            step={0.1}
                            min={0.1}
                            value={cellData.text_size != null ? cellData.text_size : 1}
                            onChange={(e) => {
                              const parsed = parseFloat(e.target.value);
                              setCellData({ ...cellData, text_size: Number.isNaN(parsed) ? null : parsed });
                            }}
                          />
                        </div>
                        <div className="tsk-input-line">
                          <label><FormattedMessage id="projects.photobooth.gif.cell.letter_spacing" /></label>
                          <input
                            type="number"
                            step={0.5}
                            value={cellData.letter_spacing != null ? cellData.letter_spacing : 0}
                            onChange={(e) => {
                              const parsed = parseFloat(e.target.value);
                              setCellData({ ...cellData, letter_spacing: Number.isNaN(parsed) ? null : parsed });
                            }}
                          />
                        </div>
                      </EditorSection>

                      <EditorSection defaultOpen={false} title={<FormattedMessage id="projects.photobooth.gif.cell.share_section" />}>
                        <div className="tsk-input-line">
                          <label><FormattedMessage id="Share.Email" /></label>
                          <input
                            type="checkbox"
                            value={cellData.email}
                            checked={cellData.email}
                            onChange={(e) => setCellData({ ...cellData, email: e.target.checked })}
                          />
                        </div>
                        <div className="tsk-input-line">
                          <label><FormattedMessage id="Share.Qr_Code" /></label>
                          <input
                            type="checkbox"
                            value={cellData.qr_code}
                            checked={cellData.qr_code}
                            onChange={(e) => setCellData({ ...cellData, qr_code: e.target.checked })}
                          />
                        </div>
                        <div className="tsk-input-line">
                          <label><FormattedMessage id="Share.Print" /></label>
                          <input
                            type="checkbox"
                            value={cellData.print}
                            checked={cellData.print}
                            onChange={(e) => setCellData({ ...cellData, print: e.target.checked })}
                          />
                        </div>
                        <div className="tsk-input-line">
                          <label><FormattedMessage id="Share.cameralabel" /></label>
                          <input
                            type="text"
                            value={cellData.cameralabel}
                            onChange={(e) => setCellData({ ...cellData, cameralabel: e.target.value })}
                          />
                        </div>
                        {/* Alternate ending: show the photo fullscreen for a few seconds, then a
                            centered retake/QR/print column instead of the preview + side-by-side cards.
                            The email card is not rendered in this layout. */}
                        <div className="tsk-input-line">
                          <label><FormattedMessage id="projects.photobooth.gif.cell.fullscreen_reveal" /></label>
                          <input
                            type="checkbox"
                            value={cellData.fullscreen_reveal}
                            checked={cellData.fullscreen_reveal}
                            onChange={(e) => setCellData({ ...cellData, fullscreen_reveal: e.target.checked })}
                          />
                        </div>
                        {cellData.fullscreen_reveal && (
                          <div className="tsk-input-line">
                            <label><FormattedMessage id="projects.photobooth.gif.cell.fullscreen_reveal_duration" /></label>
                            <input
                              type="number"
                              min={1}
                              max={30}
                              value={cellData.fullscreen_reveal_duration != null ? cellData.fullscreen_reveal_duration : 3}
                              onChange={(e) => {
                                const parsed = parseInt(e.target.value, 10);
                                const next = Number.isNaN(parsed) ? '' : Math.min(30, Math.max(1, parsed));
                                setCellData({ ...cellData, fullscreen_reveal_duration: next });
                              }}
                            />
                          </div>
                        )}
                        {/* Classic layout only: use the alternate layout's fullscreen camera geometry
                            (frame over the whole screen, live feed inside its transparent window) while
                            keeping the classic share screen. The alternate layout is always fullscreen,
                            so this is hidden there rather than offering a way to turn it off. */}
                        {!cellData.fullscreen_reveal && (
                          <div className="tsk-input-line">
                            <label><FormattedMessage id="projects.photobooth.gif.cell.fullscreen_camera" /></label>
                            <input
                              type="checkbox"
                              value={cellData.fullscreen_camera}
                              checked={cellData.fullscreen_camera}
                              onChange={(e) => setCellData({ ...cellData, fullscreen_camera: e.target.checked })}
                            />
                          </div>
                        )}
                        {/* Vertical spacing between the column layout's three blocks (retake / QR /
                            print). Only the alternate layout stacks them, so it's gated like the
                            duration above. */}
                        {cellData.fullscreen_reveal && (
                          <div className="tsk-input-line">
                            <label><FormattedMessage id="projects.photobooth.gif.cell.share_column_gap" /></label>
                            <input
                              type="range"
                              min={0}
                              max={120}
                              step={2}
                              value={cellData.share_column_gap != null ? cellData.share_column_gap : 32}
                              onChange={(e) => setCellData({ ...cellData, share_column_gap: parseInt(e.target.value, 10) })}
                            />
                            <span>{cellData.share_column_gap != null ? cellData.share_column_gap : 32}px</span>
                          </div>
                        )}
                        {/* Vertical placement of the photo on the PRINTED sheet. The frame's window sits
                            low, so a photo centred on the sheet loses its top band to the frame; 0 puts
                            the photo's top edge on the window's top edge, negative pulls it back up,
                            positive adds headroom. Deliberately OUTSIDE both layout branches: the print
                            composition is the same either way, so hiding it in the alternate layout
                            would leave a value in use with no way to change it. */}
                        <div className="tsk-input-line">
                          <label><FormattedMessage id="projects.photobooth.gif.cell.print_photo_offset" /></label>
                          <input
                            type="range"
                            min={-25}
                            max={25}
                            step={1}
                            value={cellData.print_photo_offset != null ? cellData.print_photo_offset : 0}
                            onChange={(e) => setCellData({ ...cellData, print_photo_offset: parseInt(e.target.value, 10) })}
                          />
                          <span>{cellData.print_photo_offset != null ? cellData.print_photo_offset : 0}%</span>
                        </div>
                        {/* Classic share screen only: the photo preview's width, and a vertical offset
                            that shifts the retake button and the email/QR/print cards together (useful
                            when they cover artwork in the page background). The column layout has no
                            photo preview and its own gap control, so both are hidden there. */}
                        {!cellData.fullscreen_reveal && (
                          <>
                            <div className="tsk-input-line">
                              <label><FormattedMessage id="projects.photobooth.gif.cell.share_preview_width" /></label>
                              <input
                                type="range"
                                min={30}
                                max={100}
                                step={1}
                                value={cellData.share_preview_width != null ? cellData.share_preview_width : 73}
                                onChange={(e) => setCellData({ ...cellData, share_preview_width: parseInt(e.target.value, 10) })}
                              />
                              <span>{cellData.share_preview_width != null ? cellData.share_preview_width : 73}%</span>
                            </div>
                            <div className="tsk-input-line">
                              <label><FormattedMessage id="projects.photobooth.gif.cell.share_preview_offset" /></label>
                              <input
                                type="range"
                                min={0}
                                max={60}
                                step={1}
                                value={cellData.share_preview_offset != null ? cellData.share_preview_offset : 0}
                                onChange={(e) => setCellData({ ...cellData, share_preview_offset: parseInt(e.target.value, 10) })}
                              />
                              <span>{cellData.share_preview_offset != null ? cellData.share_preview_offset : 0}%</span>
                            </div>
                            <div className="tsk-input-line">
                              <label><FormattedMessage id="projects.photobooth.gif.cell.share_controls_offset" /></label>
                              <input
                                type="range"
                                min={-20}
                                max={60}
                                step={1}
                                value={cellData.share_controls_offset != null ? cellData.share_controls_offset : 0}
                                onChange={(e) => setCellData({ ...cellData, share_controls_offset: parseInt(e.target.value, 10) })}
                              />
                              <span>{cellData.share_controls_offset != null ? cellData.share_controls_offset : 0}%</span>
                            </div>
                          </>
                        )}
                        {/* Link button under the print button on the column share screen. Its own
                            target page, separate from the cell's "Lien vers" (which drives the
                            upper-left corner hotspot). No target selected = no button rendered. */}
                        {cellData.fullscreen_reveal && (
                          <>
                            <div className="tsk-input-line">
                              <label><FormattedMessage id="projects.photobooth.gif.cell.share_link_page" /></label>
                              <select
                                name={'photobooth-share-link-to'}
                                value={cellData.share_link_page_id || ''}
                                onChange={(e) => setCellData({ ...cellData, share_link_page_id: e.target.value === '' ? null : e.target.value })}
                              >
                                <option value={''}>{intl.formatMessage({id: 'cell.links.selector.none'})}</option>
                                {project.pages.map((page) => {
                                  if(page.id === pageId) return null;
                                  return <option key={page.id} value={page.id}>{page.name}</option>;
                                })}
                              </select>
                            </div>
                            <div className="tsk-input-line">
                              <label><FormattedMessage id="projects.photobooth.gif.cell.share_link_background_color" /></label>
                              <PaletteColorPicker
                                palette={project.color_palette}
                                color={cellData.share_link_background_color}
                                onChange={(val) => {const {rgb} = val; setCellData({ ...cellData, share_link_background_color: `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})` })}}
                              />
                            </div>
                            <div className="tsk-input-line">
                              <label><FormattedMessage id="projects.photobooth.gif.cell.share_link_text_color" /></label>
                              <PaletteColorPicker
                                palette={project.color_palette}
                                color={cellData.share_link_text_color}
                                onChange={(val) => {const {rgb} = val; setCellData({ ...cellData, share_link_text_color: `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})` })}}
                              />
                            </div>
                            <div className="tsk-input-line">
                              <label><FormattedMessage id="projects.photobooth.gif.cell.share_link_border_color" /></label>
                              <PaletteColorPicker
                                palette={project.color_palette}
                                color={cellData.share_link_border_color}
                                onChange={(val) => {const {rgb} = val; setCellData({ ...cellData, share_link_border_color: `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})` })}}
                              />
                            </div>
                          </>
                        )}
                        {/* "Change background" button on the live camera step, like the OBS photobooth:
                            links back to the filters page. No target selected = no button. */}
                        <div className="tsk-input-line">
                          <label><FormattedMessage id="projects.photobooth.gif.cell.change_bg_page" /></label>
                          <select
                            name={'photobooth-change-bg-to'}
                            value={cellData.change_bg_page_id || ''}
                            onChange={(e) => setCellData({ ...cellData, change_bg_page_id: e.target.value === '' ? null : e.target.value })}
                          >
                            <option value={''}>{intl.formatMessage({id: 'cell.links.selector.none'})}</option>
                            {project.pages.map((page) => {
                              if(page.id === pageId) return null;
                              return <option key={page.id} value={page.id}>{page.name}</option>;
                            })}
                          </select>
                        </div>
                        {cellData.change_bg_page_id && (
                          <div className="tsk-input-line">
                            <label><FormattedMessage id="projects.photobooth.gif.cell.change_bg_button_position" /></label>
                            <input
                              type="number"
                              step={1}
                              min={0}
                              max={100}
                              value={cellData.change_bg_button_position != null ? cellData.change_bg_button_position : 8}
                              onChange={(e) => {
                                const parsed = parseInt(e.target.value, 10);
                                setCellData({ ...cellData, change_bg_button_position: Number.isNaN(parsed) ? null : parsed });
                              }}
                            />
                          </div>
                        )}
                        {cellData.qr_code && (
                          <div className="tsk-input-line">
                            <label><FormattedMessage id="projects.photobooth.gif.cell.qr_code_size" /></label>
                            <input
                              type="range"
                              min={60}
                              max={500}
                              step={10}
                              value={cellData.qr_code_size != null ? cellData.qr_code_size : 120}
                              onChange={(e) => setCellData({ ...cellData, qr_code_size: parseInt(e.target.value, 10) })}
                            />
                            <span>{cellData.qr_code_size != null ? cellData.qr_code_size : 120}px</span>
                          </div>
                        )}
                        {cellData.qr_code && (
                          <div className="tsk-input-line">
                            <label><FormattedMessage id="projects.photobooth.gif.cell.qr_title_size" /></label>
                            <input
                              type="range"
                              min={0.5}
                              max={3}
                              step={0.1}
                              value={cellData.qr_title_size != null ? cellData.qr_title_size : 1}
                              onChange={(e) => setCellData({ ...cellData, qr_title_size: parseFloat(e.target.value) })}
                            />
                            <span>{(cellData.qr_title_size != null ? cellData.qr_title_size : 1).toFixed(1)}x</span>
                          </div>
                        )}
                        {cellData.qr_code && (
                          <div className="tsk-input-line">
                            <label><FormattedMessage id="projects.photobooth.gif.cell.qr_title_bold" /></label>
                            <input
                              type="checkbox"
                              checked={cellData.qr_title_bold !== false}
                              onChange={(e) => setCellData({ ...cellData, qr_title_bold: e.target.checked })}
                            />
                          </div>
                        )}
                        {cellData.print && (
                          <div className="tsk-input-line">
                            <label><FormattedMessage id="projects.photobooth.gif.cell.print_title_size" /></label>
                            <input
                              type="range"
                              min={0.5}
                              max={3}
                              step={0.1}
                              value={cellData.print_title_size != null ? cellData.print_title_size : 1}
                              onChange={(e) => setCellData({ ...cellData, print_title_size: parseFloat(e.target.value) })}
                            />
                            <span>{(cellData.print_title_size != null ? cellData.print_title_size : 1).toFixed(1)}x</span>
                          </div>
                        )}
                        {cellData.print && (
                          <div className="tsk-input-line">
                            <label><FormattedMessage id="projects.photobooth.gif.cell.print_title_bold" /></label>
                            <input
                              type="checkbox"
                              checked={cellData.print_title_bold !== false}
                              onChange={(e) => setCellData({ ...cellData, print_title_bold: e.target.checked })}
                            />
                          </div>
                        )}
                        {/* max 2, not the 3 the title sliders allow: both buttons sit in fixed boxes
                            (520x78.75px in the column layout) with nowrap labels, so a long label like
                            "REPRENDRE LA PHOTO" overflows past ~2x. */}
                        <div className="tsk-input-line">
                          <label><FormattedMessage id="projects.photobooth.gif.cell.button_retake_text_size" /></label>
                          <input
                            type="range"
                            min={0.5}
                            max={2}
                            step={0.1}
                            value={cellData.button_retake_text_size != null ? cellData.button_retake_text_size : 1}
                            onChange={(e) => setCellData({ ...cellData, button_retake_text_size: parseFloat(e.target.value) })}
                          />
                          <span>{(cellData.button_retake_text_size != null ? cellData.button_retake_text_size : 1).toFixed(1)}x</span>
                        </div>
                        {/* Defaults to true (the buttons have always been bold), so `!== false` rather
                            than the plain truthy check the other checkboxes use. */}
                        <div className="tsk-input-line">
                          <label><FormattedMessage id="projects.photobooth.gif.cell.button_retake_text_bold" /></label>
                          <input
                            type="checkbox"
                            checked={cellData.button_retake_text_bold !== false}
                            onChange={(e) => setCellData({ ...cellData, button_retake_text_bold: e.target.checked })}
                          />
                        </div>
                        {cellData.print && (
                          <div className="tsk-input-line">
                            <label><FormattedMessage id="projects.photobooth.gif.cell.print_text_size" /></label>
                            <input
                              type="range"
                              min={0.5}
                              max={2}
                              step={0.1}
                              value={cellData.print_text_size != null ? cellData.print_text_size : 1}
                              onChange={(e) => setCellData({ ...cellData, print_text_size: parseFloat(e.target.value) })}
                            />
                            <span>{(cellData.print_text_size != null ? cellData.print_text_size : 1).toFixed(1)}x</span>
                          </div>
                        )}
                        {cellData.print && (
                          <div className="tsk-input-line">
                            <label><FormattedMessage id="projects.photobooth.gif.cell.print_text_bold" /></label>
                            <input
                              type="checkbox"
                              checked={cellData.print_text_bold !== false}
                              onChange={(e) => setCellData({ ...cellData, print_text_bold: e.target.checked })}
                            />
                          </div>
                        )}
                      </EditorSection>

                      <EditorSection defaultOpen={false} title={<FormattedMessage id="projects.photobooth.gif.cell.photo_format" />}>
                        <div className="tsk-input-line">
                          <label><FormattedMessage id="projects.photobooth.gif.cell.photo_format" /></label>
                          <select
                            value={cellData.photo_format || 'default'}
                            onChange={(e) => setCellData({ ...cellData, photo_format: e.target.value })}
                          >
                            <option value="default">10x15</option>
                            <option value="square">15x15</option>
                          </select>
                        </div>
                        {(cellData.photo_format === 'default' || !cellData.photo_format) && (
                          <div className="tsk-input-line">
                            <label><FormattedMessage id="projects.photobooth.gif.cell.panini_print" /></label>
                            <input
                              type="checkbox"
                              value={cellData.panini_print}
                              checked={cellData.panini_print}
                              onChange={(e) => setCellData({ ...cellData, panini_print: e.target.checked })}
                            />
                          </div>
                        )}
                        <div className="tsk-input-line">
                          <label><FormattedMessage id="projects.photobooth.gif.cell.camera_resolution" /></label>
                          <select
                            value={cellData.camera_resolution || '1080'}
                            onChange={(e) => setCellData({ ...cellData, camera_resolution: e.target.value })}
                          >
                            <option value="1080">1080p (1920x1080)</option>
                            <option value="1440">1440p (2560x1440)</option>
                            <option value="2160">4K (3840x2160)</option>
                          </select>
                        </div>
                        <div className="tsk-input-line">
                          <label><FormattedMessage id="projects.photobooth.gif.cell.camera_rotation" /></label>
                          <select
                            value={cellData.camera_rotation != null ? cellData.camera_rotation : 0}
                            onChange={(e) => setCellData({ ...cellData, camera_rotation: parseInt(e.target.value, 10) })}
                          >
                            <option value={0}>0°</option>
                            <option value={90}>90°</option>
                            <option value={180}>180°</option>
                            <option value={270}>270°</option>
                          </select>
                        </div>
                        <div className="tsk-input-line">
                          <label><FormattedMessage id="projects.photobooth.gif.cell.mirror_image" /></label>
                          <input
                            type="checkbox"
                            value={cellData.mirror_image}
                            checked={cellData.mirror_image}
                            onChange={(e) => setCellData({ ...cellData, mirror_image: e.target.checked })}
                          />
                        </div>
                        <div className="tsk-input-line">
                          <label><FormattedMessage id="projects.photobooth.gif.cell.remove_background" /></label>
                          <input
                            type="checkbox"
                            value={cellData.remove_background}
                            checked={cellData.remove_background}
                            onChange={(e) => setCellData({ ...cellData, remove_background: e.target.checked })}
                          />
                        </div>
                        {cellData.remove_background && (
                          <div className="tsk-input-line tsk-input-line--full">
                            <label><FormattedMessage id="projects.photobooth.gif.cell.background_image" /></label>
                            <ImageUploader
                              onUpload={(e) => {
                                setCellData({ ...cellData, background_image_uri: e });
                              }}
                              value={cellData.background_image_uri}
                            />
                          </div>
                        )}
                      </EditorSection>

                      <EditorSection defaultOpen={false} title={<FormattedMessage id="projects.photobooth.gif.cell.filter_section" />}>
                        {cellData.photo_format === 'square' && (
                          <div className="tsk-input-line tsk-input-line--full">
                            <label><FormattedMessage id="projects.photobooth.gif.cell.square_frame" /></label>
                            <ImageUploader
                              onUpload={(e) => {
                                setCellData({ ...cellData, square_gif_uri: e });
                              }}
                              value={cellData.square_gif_uri}
                            />
                          </div>
                        )}
                        {(cellData.photo_format === 'default' || !cellData.photo_format) && (
                          <div className="tsk-input-line tsk-input-line--full">
                            <label><FormattedMessage id="projects.photobooth.gif.cell.gif_uri" defaultMessage="GIF" /></label>
                            <ImageUploader
                              onUpload={(e) => {
                                setCellData({ ...cellData, gif_uri: e });
                              }}
                              value={cellData.gif_uri}
                            />
                          </div>
                        )}
                      </EditorSection>

                      <EditorSection defaultOpen={false} title={<FormattedMessage id="projects.photobooth.gif.cell.timer_section" />}>
                        <div className="tsk-input-line">
                          <label><FormattedMessage id="projects.photobooth.gif.cell.photo_timer" /></label>
                          <input
                            type="number"
                            min={1}
                            max={10}
                            value={cellData.photo_timer != null ? cellData.photo_timer : 3}
                            onChange={(e) => {
                              const parsed = parseInt(e.target.value, 10);
                              const next = Number.isNaN(parsed) ? '' : Math.min(10, Math.max(1, parsed));
                              setCellData({ ...cellData, photo_timer: next });
                            }}
                          />
                        </div>
                        <div className="tsk-input-line">
                          <label><FormattedMessage id="projects.photobooth.gif.cell.photo_timer_direction" /></label>
                          <select
                            value={cellData.photo_timer_direction || 'desc'}
                            onChange={(e) => setCellData({ ...cellData, photo_timer_direction: e.target.value })}
                          >
                            <option value="desc">3, 2, 1</option>
                            <option value="asc">1, 2, 3</option>
                          </select>
                        </div>
                      </EditorSection>

                      <EditorSection
                        title={<FormattedMessage id="projects.photobooth.gif.cell.collect_user_info" />}
                        defaultOpen={false}
                      >
                        <div className="tsk-input-line">
                          <label><FormattedMessage id="projects.photobooth.gif.cell.collect_user_info" /></label>
                          <input
                            type="checkbox"
                            value={cellData.collect_user_info}
                            checked={cellData.collect_user_info}
                            onChange={(e) => setCellData({ ...cellData, collect_user_info: e.target.checked })}
                          />
                        </div>
                        {cellData.collect_user_info && (
                          <>
                            <div className="tsk-input-line">
                              <label><FormattedMessage id="projects.photobooth.gif.cell.user_info_bar_color" /></label>
                              <PaletteColorPicker
                                palette={project.color_palette}
                                color={cellData.user_info_bar_color}
                                onChange={(val) => {const {rgb} = val; setCellData({ ...cellData, user_info_bar_color: `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})` })}}
                              />
                            </div>
                            <div className="tsk-input-line">
                              <label><FormattedMessage id="projects.photobooth.gif.cell.user_info_text_color" /></label>
                              <PaletteColorPicker
                                palette={project.color_palette}
                                color={cellData.user_info_text_color}
                                onChange={(val) => {const {rgb} = val; setCellData({ ...cellData, user_info_text_color: `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})` })}}
                              />
                            </div>
                            <div className="tsk-input-line">
                              <label><FormattedMessage id="projects.photobooth.gif.cell.user_info_text_size" /></label>
                              <input
                                type="range"
                                min={0.5}
                                max={2}
                                step={0.1}
                                value={cellData.user_info_text_size != null ? cellData.user_info_text_size : 1}
                                onChange={(e) => setCellData({ ...cellData, user_info_text_size: parseFloat(e.target.value) })}
                              />
                              <span>{(cellData.user_info_text_size != null ? cellData.user_info_text_size : 1).toFixed(1)}x</span>
                            </div>
                            <div className="tsk-input-line">
                              <label><FormattedMessage id="projects.photobooth.gif.cell.user_info_text_position" /></label>
                              <input
                                type="range"
                                min={2}
                                max={40}
                                step={1}
                                value={cellData.user_info_text_position != null ? cellData.user_info_text_position : 12}
                                onChange={(e) => setCellData({ ...cellData, user_info_text_position: parseInt(e.target.value, 10) })}
                              />
                              <span>{cellData.user_info_text_position != null ? cellData.user_info_text_position : 12}%</span>
                            </div>
                            <div className="tsk-input-line">
                              <label><FormattedMessage id="projects.photobooth.gif.cell.user_info_text_h_position" /></label>
                              <input
                                type="range"
                                min={0}
                                max={100}
                                step={1}
                                value={cellData.user_info_text_h_position != null ? cellData.user_info_text_h_position : 50}
                                onChange={(e) => setCellData({ ...cellData, user_info_text_h_position: parseInt(e.target.value, 10) })}
                              />
                              <span>{cellData.user_info_text_h_position != null ? cellData.user_info_text_h_position : 50}%</span>
                            </div>
                          </>
                        )}
                      </EditorSection>
                    </>
                  )}

                  <EditorSection defaultOpen={false} title={<FormattedMessage id="projects.photobooth.gif.cell.description_text" />}>
                    <div className="tsk-input-line">
                      <label><FormattedMessage id="projects.photobooth.gif.cell.button_take_text" /></label>
                      <input
                        type="text"
                        value={cellData.button_take_text}
                        onChange={(e) => setCellData({ ...cellData, button_take_text: e.target.value })}
                      />
                    </div>
                    <div className="tsk-input-line">
                      <label><FormattedMessage id="projects.photobooth.gif.cell.button_retake_text" /></label>
                      <input
                        type="text"
                        value={cellData.button_retake_text}
                        onChange={(e) => setCellData({ ...cellData, button_retake_text: e.target.value })}
                      />
                    </div>
                    <div className="tsk-input-line">
                      <label><FormattedMessage id="projects.photobooth.gif.cell.button_download_text" /></label>
                      <input
                        type="text"
                        value={cellData.button_download_text}
                        onChange={(e) => setCellData({ ...cellData, button_download_text: e.target.value })}
                      />
                    </div>
                    <div className="tsk-input-line">
                      <label><FormattedMessage id="projects.photobooth.gif.cell.send_text" /></label>
                      <input
                        type="text"
                        value={cellData.send_text}
                        onChange={(e) => setCellData({ ...cellData, send_text: e.target.value })}
                      />
                    </div>
                    <div className="tsk-input-line">
                      <label><FormattedMessage id="projects.photobooth.gif.cell.sent_text" /></label>
                      <input
                        type="text"
                        value={cellData.sent_text}
                        onChange={(e) => setCellData({ ...cellData, sent_text: e.target.value })}
                      />
                    </div>
                    <div className="tsk-input-line">
                      <label><FormattedMessage id="projects.photobooth.gif.cell.look_text" /></label>
                      <input
                        type="text"
                        value={cellData.look_text}
                        onChange={(e) => setCellData({ ...cellData, look_text: e.target.value })}
                      />
                    </div>
                    <div className="tsk-input-line">
                      <label><FormattedMessage id="projects.photobooth.gif.cell.description_text" /></label>
                      <input
                        type="text"
                        value={cellData.description_text}
                        onChange={(e) => setCellData({ ...cellData, description_text: e.target.value })}
                      />
                    </div>
                    <div className="tsk-input-line">
                      <label><FormattedMessage id="projects.photobooth.gif.cell.conditions1_text" /></label>
                      <input
                        type="text"
                        value={cellData.conditions1_text}
                        onChange={(e) => setCellData({ ...cellData, conditions1_text: e.target.value })}
                      />
                    </div>
                    <div className="tsk-input-line">
                      <label><FormattedMessage id="projects.photobooth.gif.cell.conditions2_text" /></label>
                      <input
                        type="text"
                        value={cellData.conditions2_text}
                        onChange={(e) => setCellData({ ...cellData, conditions2_text: e.target.value })}
                      />
                    </div>
                    <div className="tsk-input-line">
                      <label><FormattedMessage id="projects.photobooth.gif.cell.send_by_email_text" /></label>
                      <input
                        type="text"
                        value={cellData.send_by_email_text || ''}
                        onChange={(e) => setCellData({ ...cellData, send_by_email_text: e.target.value })}
                      />
                    </div>
                    {/* Progress screen shown while the photo is processed: first message, then the
                        second. Blank falls back to the built-in per-language string. */}
                    <div className="tsk-input-line">
                      <label><FormattedMessage id="projects.photobooth.gif.cell.preparing_photo_text" /></label>
                      <input
                        type="text"
                        value={cellData.preparing_photo_text || ''}
                        onChange={(e) => setCellData({ ...cellData, preparing_photo_text: e.target.value })}
                      />
                    </div>
                    <div className="tsk-input-line">
                      <label><FormattedMessage id="projects.photobooth.gif.cell.almost_there_text" /></label>
                      <input
                        type="text"
                        value={cellData.almost_there_text || ''}
                        onChange={(e) => setCellData({ ...cellData, almost_there_text: e.target.value })}
                      />
                    </div>
                    <div className="tsk-input-line">
                      <label><FormattedMessage id="projects.photobooth.gif.cell.print_title_text" /></label>
                      <input
                        type="text"
                        value={cellData.print_title_text || ''}
                        onChange={(e) => setCellData({ ...cellData, print_title_text: e.target.value })}
                      />
                    </div>
                    <div className="tsk-input-line">
                      <label><FormattedMessage id="projects.photobooth.gif.cell.print_text" /></label>
                      <input
                        type="text"
                        value={cellData.print_text || ''}
                        onChange={(e) => setCellData({ ...cellData, print_text: e.target.value })}
                      />
                    </div>
                    <div className="tsk-input-line">
                      <label><FormattedMessage id="projects.photobooth.gif.cell.printed_text" /></label>
                      <input
                        type="text"
                        value={cellData.printed_text || ''}
                        onChange={(e) => setCellData({ ...cellData, printed_text: e.target.value })}
                      />
                    </div>
                    <div className="tsk-input-line">
                      <label><FormattedMessage id="projects.photobooth.gif.cell.share_link_text" /></label>
                      <input
                        type="text"
                        value={cellData.share_link_text || ''}
                        onChange={(e) => setCellData({ ...cellData, share_link_text: e.target.value })}
                      />
                    </div>
                    <div className="tsk-input-line">
                      <label><FormattedMessage id="projects.photobooth.gif.cell.change_bg_text" /></label>
                      <input
                        type="text"
                        value={cellData.change_bg_text || ''}
                        onChange={(e) => setCellData({ ...cellData, change_bg_text: e.target.value })}
                      />
                    </div>
                    {/* Mail envoyé depuis l'écran de partage. Champ vide = texte par défaut. */}
                    <div className="tsk-input-line">
                      <label><FormattedMessage id="projects.photobooth.gif.cell.email_subject" /></label>
                      <input
                        type="text"
                        value={cellData.email_subject || ''}
                        onChange={(e) => setCellData({ ...cellData, email_subject: e.target.value })}
                      />
                    </div>
                    <div className="tsk-input-line">
                      <label><FormattedMessage id="projects.photobooth.gif.cell.email_body" /></label>
                      <textarea
                        rows={5}
                        value={cellData.email_body || ''}
                        onChange={(e) => setCellData({ ...cellData, email_body: e.target.value })}
                      />
                    </div>
                    {!language && (
                      <div className="tsk-input-line">
                        <label><FormattedMessage id="projects.photobooth.gif.cell.email_from" /></label>
                        <input
                          type="text"
                          value={cellData.email_from || ''}
                          onChange={(e) => setCellData({ ...cellData, email_from: e.target.value })}
                        />
                      </div>
                    )}
                  </EditorSection>
                </div>
              );
            }}
          </Query>
          <button
            className="tsk-button"
            onClick={() => updateCell({ variables: { input: removeTypenameDeep(!language ? {
              id: cellData.id,
              send_email: cellData.send_email,
              gif_uri: cellData.gif_uri,
              background_color: cellData.background_color,
              text_color: cellData.text_color,
              button_download_background_color: cellData.button_download_background_color,
              button_download_text_color: cellData.button_download_text_color,
              button_retake_background_color: cellData.button_retake_background_color,
              button_retake_border_color: cellData.button_retake_border_color,
              button_retake_text_color: cellData.button_retake_text_color,
              button_print_background_color: cellData.button_print_background_color,
              qr_card_background_color: cellData.qr_card_background_color,
              email_card_background_color: cellData.email_card_background_color,
              email_input_background_color: cellData.email_input_background_color,
              email_input_text_color: cellData.email_input_text_color,
              send_button_background_color: cellData.send_button_background_color,
              send_button_text_color: cellData.send_button_text_color,
              qr_code_color: cellData.qr_code_color,
              loader_background_color: cellData.loader_background_color,
              loader_spinner_color: cellData.loader_spinner_color,
              button_download_text: cellData.button_download_text,
              button_retake_text: cellData.button_retake_text,
              button_take_text: cellData.button_take_text,
              send_text: cellData.send_text,
              sent_text: cellData.sent_text,
              look_text: cellData.look_text,
              description_text: cellData.description_text,
              conditions1_text: cellData.conditions1_text,
              conditions2_text: cellData.conditions2_text,
              send_by_email_text: cellData.send_by_email_text,
              print_text: cellData.print_text,
              print_title_text: cellData.print_title_text,
              printed_text: cellData.printed_text,
              preparing_photo_text: cellData.preparing_photo_text,
              almost_there_text: cellData.almost_there_text,
              print: cellData.print,
              cameralabel: cellData.cameralabel,
              qr_code: cellData.qr_code,
              email: cellData.email,
              remove_background: cellData.remove_background,
              mirror_image: cellData.mirror_image,
              background_image_uri: cellData.background_image_uri,
              photo_format: cellData.photo_format,
              square_gif_uri: cellData.square_gif_uri,
              photo_timer: cellData.photo_timer === '' || cellData.photo_timer == null ? null : parseInt(cellData.photo_timer, 10),
              photo_timer_direction: cellData.photo_timer_direction,
              panini_print: cellData.panini_print,
              camera_rotation: cellData.camera_rotation == null ? 0 : parseInt(cellData.camera_rotation, 10),
              camera_resolution: cellData.camera_resolution || '1080',
              collect_user_info: !!cellData.collect_user_info,
              user_info_bar_color: cellData.user_info_bar_color,
              user_info_text_color: cellData.user_info_text_color,
              user_info_text_size: cellData.user_info_text_size == null ? 1 : parseFloat(cellData.user_info_text_size),
              user_info_text_position: cellData.user_info_text_position == null ? 12 : parseInt(cellData.user_info_text_position, 10),
              user_info_text_h_position: cellData.user_info_text_h_position == null ? 50 : parseInt(cellData.user_info_text_h_position, 10),
              text_font: cellData.text_font || null,
              text_size: cellData.text_size == null ? null : parseFloat(cellData.text_size),
              letter_spacing: cellData.letter_spacing == null ? null : parseFloat(cellData.letter_spacing),
              fullscreen_reveal: !!cellData.fullscreen_reveal,
              fullscreen_camera: !!cellData.fullscreen_camera,
              fullscreen_reveal_duration: cellData.fullscreen_reveal_duration === '' || cellData.fullscreen_reveal_duration == null
                ? 3 : parseInt(cellData.fullscreen_reveal_duration, 10),
              qr_code_size: cellData.qr_code_size == null ? 120 : parseInt(cellData.qr_code_size, 10),
              qr_title_size: cellData.qr_title_size == null ? 1 : parseFloat(cellData.qr_title_size),
              print_title_size: cellData.print_title_size == null ? 1 : parseFloat(cellData.print_title_size),
              button_retake_text_size: cellData.button_retake_text_size == null ? 1 : parseFloat(cellData.button_retake_text_size),
              // `!== false`, not `!!`: these default to true, and `!!undefined` would un-bold a booth on its first save.
              button_retake_text_bold: cellData.button_retake_text_bold !== false,
              print_text_size: cellData.print_text_size == null ? 1 : parseFloat(cellData.print_text_size),
              print_text_bold: cellData.print_text_bold !== false,
              qr_title_bold: cellData.qr_title_bold !== false,
              print_title_bold: cellData.print_title_bold !== false,
              share_column_gap: cellData.share_column_gap == null ? 32 : parseInt(cellData.share_column_gap, 10),
              // `== null`, not falsy: a deliberate 0 offset must survive the save.
              share_preview_width: cellData.share_preview_width == null ? 73 : parseInt(cellData.share_preview_width, 10),
              share_controls_offset: cellData.share_controls_offset == null ? 0 : parseInt(cellData.share_controls_offset, 10),
              share_preview_offset: cellData.share_preview_offset == null ? 0 : parseInt(cellData.share_preview_offset, 10),
              print_photo_offset: cellData.print_photo_offset == null ? 0 : parseInt(cellData.print_photo_offset, 10),
              share_link_page_id: cellData.share_link_page_id || null,
              change_bg_page_id: cellData.change_bg_page_id || null,
              change_bg_button_position: cellData.change_bg_button_position == null || cellData.change_bg_button_position === '' ? null : parseInt(cellData.change_bg_button_position, 10),
              share_link_background_color: cellData.share_link_background_color,
              share_link_text_color: cellData.share_link_text_color,
              share_link_border_color: cellData.share_link_border_color,
              share_link_text: cellData.share_link_text,
              button_take_text_color: cellData.button_take_text_color,
              look_text_color: cellData.look_text_color,
              arrows_color: cellData.arrows_color,
              email_subject: cellData.email_subject,
              email_body: htmlLineBreaks(cellData.email_body),
              email_from: cellData.email_from,
            } : {
              button_download_text: cellData.button_download_text,
              button_retake_text: cellData.button_retake_text,
              button_take_text: cellData.button_take_text,
              gif_uri: cellData.gif_uri,
              send_text: cellData.send_text,
              sent_text: cellData.sent_text,
              look_text: cellData.look_text,
              description_text: cellData.description_text,
              conditions1_text: cellData.conditions1_text,
              conditions2_text: cellData.conditions2_text,
              send_by_email_text: cellData.send_by_email_text,
              print_text: cellData.print_text,
              print_title_text: cellData.print_title_text,
              printed_text: cellData.printed_text,
              preparing_photo_text: cellData.preparing_photo_text,
              almost_there_text: cellData.almost_there_text,
              share_link_text: cellData.share_link_text,
              change_bg_text: cellData.change_bg_text,
              email_subject: cellData.email_subject,
              email_body: htmlLineBreaks(cellData.email_body),
              language_code: language.code,
              cell_id: cellData.id}) } })}
            disabled={mutationLoading}
          >
            {mutationLoading ? "Updating..." : "Update"}
          </button>

          <PhotoboothCellStatsButton cell={cellData} />
          <PhotoboothCellPhotosZipButton cell={cellData} />
        </>
      )}
    </Mutation>
  );
});

// sanitizeText côté back supprime \p{C} (donc les retours à la ligne) sur email_body, aussi bien
// sur la colonne que sur la traduction. Le corps étant injecté dans du HTML, on convertit avant
// l'envoi pour que le textarea se comporte normalement.
function htmlLineBreaks(text) {
  return typeof text === 'string' ? text.replace(/\r?\n/g, '<br>') : text;
}

function removeTypenameDeep(obj) {
  if (Array.isArray(obj)) {
    return obj.map(removeTypenameDeep);
  } else if (obj !== null && typeof obj === 'object') {
    const newObj = {};
    for (const key in obj) {
      if (key !== '__typename') {
        newObj[key] = removeTypenameDeep(obj[key]);
      }
    }
    return newObj;
  }
  return obj;
}

export default withRouter(PhotoboothGifCell2EditorWrapper);
